var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_7768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 4.89582H12.2854M2.45898 4.89582V10.3003C2.45898 10.9882 2.45898 11.3321 2.59287 11.595C2.71063 11.8261 2.89853 12.014 3.12963 12.1317C3.39188 12.2656 3.7358 12.2656 4.42242 12.2656H10.3219C11.0085 12.2656 11.3518 12.2656 11.6141 12.1317C11.8456 12.0138 12.0335 11.8259 12.1515 11.595C12.2854 11.3321 12.2854 10.9894 12.2854 10.3028V4.89582M2.45898 4.89582V4.40451C2.45898 3.71666 2.45898 3.37274 2.59287 3.10988C2.71078 2.87835 2.8981 2.69103 3.12963 2.57312C3.39249 2.43923 3.73641 2.43923 4.42426 2.43923H4.91558M12.2854 4.89582V4.40266C12.2854 3.71605 12.2854 3.37212 12.1515 3.10988C12.0335 2.87868 11.8454 2.69077 11.6141 2.57312C11.3518 2.43923 11.0079 2.43923 10.3201 2.43923H9.82876M4.91558 2.43923H9.82876M4.91558 2.43923V1.21094M9.82876 2.43923V1.21094",
    stroke: "#4B5563",
    strokeWidth: 1.2283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_7768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7395,
    height: 14.7395,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiCalendar);
export default __webpack_public_path__ + "static/media/ci_calendar.a620d2d5776108a4f12bb80f7fc168da.svg";
export { ForwardRef as ReactComponent };